import './other-apps.style.scss';
import {
  Typography,
  Icon,
  Button,
  SelectionCard,
  BUTTON_SIZE,
  BUTTON_VARIANT
} from '@sanlam-glacier/app-common/components';
import { useIsMounted } from '@sanlam-glacier/app-common/hooks';
import { useConfig } from 'providers/config/ConfigProvider';

export const OtherApps = () => {
  const mounted = useIsMounted();
  const env = useConfig();

  const selectionCardData = [
    {
      title: 'Glacier International: AF Global Platform',
      subtitle:
        'Expand your investment universe by diversifying your portfolio across countries and currencies',
      icon: <Icon icon={'action_language'} />,
      link: env.redirects.GlacierInternational,
      linkDescription:
        'When redirected to Glacier International, you will be required to enter a username and password. This is your username and password to access AF Global Platform in Glacier International.',
      linkedExtendedDescription:
        'If you have not yet registered, please follow the instructions presented when you are redirected.'
    }
  ];
  return (
    <>
      <Typography variant={Typography.VARIANT.H2} weight={Typography.WEIGHT.BOLD}>
        Explore our other apps
      </Typography>
      <br />
      <div className='selections'>
        {selectionCardData.map((selection, index) => (
          <div key={index} className='selection-card-wrapper'>
            <SelectionCard
              className={`selection-card ${mounted ? 'fade-in' : ''}`}
              size={SelectionCard.SIZE.SMALL}
              title={
                <div>
                  <div className='selection-icon'>
                    <Typography variant={Typography.VARIANT.H1}>{selection.icon}</Typography>
                  </div>
                  <Typography
                    variant={Typography.VARIANT.H4}
                    weight={Typography.WEIGHT.MEDIUM}
                    align={Typography.ALIGN.LEFT}
                  >
                    {selection.title}
                  </Typography>
                  <hr />
                </div>
              }
              subtitle={
                <>
                  <div className='content-wrapper'>
                    <div className='content'>
                      <div className='main-content'>
                        <Typography
                          color={Typography.COLOR.TERTIARY}
                          variant={Typography.VARIANT.B2}
                        >
                          {selection.subtitle}
                        </Typography>
                      </div>
                      <div className='main-content'>
                        <Typography
                          color={Typography.COLOR.TERTIARY}
                          variant={Typography.VARIANT.B3}
                        >
                          {selection.linkDescription
                            ? selection.linkDescription
                            : `If you redirect to ${selection.title}, a new browser tab will open.`}
                        </Typography>

                        <div className='extended-desc'>
                          <Typography
                            color={Typography.COLOR.TERTIARY}
                            variant={Typography.VARIANT.B3}
                          >
                            {selection.linkedExtendedDescription
                              ? selection.linkedExtendedDescription
                              : ''}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <a
                      href={selection.link}
                      target='_blank'
                      rel='noreferrer'
                      role='button'
                      aria-label={selection.title}
                      key={index}
                      className='btn-holder'
                    >
                      <Button
                        color={Button.COLOR.NORMAL}
                        mode={Button.MODE.LIGHT}
                        size={BUTTON_SIZE.MEDIUM}
                        variant={BUTTON_VARIANT.TERTIARY}
                      >
                        Open
                      </Button>
                    </a>
                  </div>
                </>
              }
            />
          </div>
        ))}
      </div>
    </>
  );
};
